import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Small helper — safe fire-and-forget POST. Skips the request entirely when
// no auth token is set (these tracking endpoints require auth; hitting them
// anonymously just adds noisy "Failed to load resource 401" errors in the
// browser console without any user-visible benefit).
const post = (path, body) => {
  try {
    const token = localStorage.getItem("alankar_token");
    if (!token) return; // anonymous → do not fire, skip silently
    axios
      .post(`${API}${path}`, body)
      .catch((err) => {
        // Fire-and-forget — do NOT surface to the user, but log for debugging.
        if (process.env.NODE_ENV !== "production") {
          console.warn(`[track] ${path} failed:`, err?.message || err);
        }
      });
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(`[track] ${path} threw:`, err?.message || err);
    }
  }
};

// Trim a design object to the minimum the backend expects.
const slim = (d) => {
  if (!d) return null;
  return {
    id: d.id,
    name: d.name,
    category: d.category && d.category.label,
    subCategory: d.subCategory && d.subCategory.label,
    purity: d.purity,
    weight: typeof d.weight === "number" ? d.weight : undefined,
    weightUnit: d.weightUnit,
    gender: d.gender || "unisex",
  };
};

export const trackDesignView = (design) => {
  if (!design) return;
  post("/events/design-view", { design: slim(design) });
};

export const trackWishlist = (design, action = "add") => {
  if (!design) return;
  post("/events/wishlist", { design: slim(design), action });
};

export const trackWhatsApp = ({ design, designs, source = "generic" } = {}) => {
  const body = { source };
  if (design) body.design = slim(design);
  if (designs && designs.length) body.designs = designs.map(slim);
  post("/events/whatsapp", body);
};
